setUserLocalDataLanguageAlertBarAccepted